import styled from 'styled-components'

export const Main = styled.div`
    padding-top: 75px;
    text-align: justify;
    padding-bottom: 50px;

    h1 {
        color: ${(props) => {return props.theme.colorPrimary}};
    }

    .figura1 {
        height: 100%;
        max-width: 100%;
        margin-bottom: 10px;
    }

    .figura2 {
        height: 100%;
        max-width: 100%;
        margin-bottom: 10px;
    }

    .figura3 {
        height: 100%;
        max-width: 100%;
    }

    .figura2, .figura4 {
        display: flex;
        justify-content: center;

        img {
            height: 100%;
            max-width: 100%;
        }
    }
`
